import { useContext } from "react";
import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { ArrowLeft, ArrowLeftCircle, List } from "react-feather";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

export default function DocumentHeader() {
    const navigate = useNavigate()

    return (
        <>
            <Helmet title="TMS Document Signing" />
            <Row>
                <Col md={12} className="d-flex align-items-center justify-content-start">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-top`}>Return to List</Tooltip>}
                    >
                        <Button
                            variant="info"
                            className="float-start  ms-3  "
                            onClick={() => {
                                navigate("/tms/batches/summary");
                            }}
                        >
                            <ArrowLeft size={15}></ArrowLeft>
                        </Button>
                    </OverlayTrigger>
                    <h2 className="p-2">
                        Class - Sign BCA Forms
                    </h2>
                </Col>
            </Row>
        </>
    )
}